export default __webpack_public_path__ + "static/bb_banner3-4d1e2cf88ad572b8eef474462e2d9c1b.jpg";